import React, { useCallback } from 'react';

import type { TriggerProps as PopupTriggerProps } from '@atlaskit/popup/types';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets.ts';

import { BylineConnectionsWrapper } from './BylineConnectionsTrigger.tsx';
import {
	BylineConnectionsMenuContent,
	type BylineConnectionsMenuContentProps,
} from './BylineConnectionsMenuContent.tsx';
import {
	BylineConnectionsTooltipTrigger,
	type BylineConnectionsTooltipTriggerProps,
} from './BylineConnectionsTooltipTrigger.tsx';

type BylineConnectionsPopupProps = {
	isOpen: boolean;
	onClose: () => void;
	menuProps: BylineConnectionsMenuContentProps;
	triggerProps: Omit<BylineConnectionsTooltipTriggerProps, 'isOpen' | 'popupTriggerProps'>;
};

export const BylineConnectionsPopup = ({
	isOpen,
	onClose,
	menuProps,
	triggerProps,
}: BylineConnectionsPopupProps): React.JSX.Element => {
	const { Popup } = useChoreographerAssets();

	const content = useCallback(() => <BylineConnectionsMenuContent {...menuProps} />, [menuProps]);
	const trigger = useCallback(
		(popupTriggerProps: PopupTriggerProps) => (
			<BylineConnectionsTooltipTrigger
				{...triggerProps}
				isOpen={isOpen}
				popupTriggerProps={popupTriggerProps}
			/>
		),
		[triggerProps, isOpen],
	);
	return (
		<BylineConnectionsWrapper>
			<Popup
				isOpen={isOpen}
				onClose={onClose}
				placement="bottom-start"
				shouldReturnFocus={false}
				content={content}
				trigger={trigger}
			/>
		</BylineConnectionsWrapper>
	);
};
